import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import type { SnackbarState } from '../hooks/useSnackbar';

interface SnackbarAlertProps {
  snackbar: SnackbarState;
  onClose: () => void;
  autoHideDuration?: number;
  anchorOrigin?: { vertical: 'top' | 'bottom'; horizontal: 'left' | 'center' | 'right' };
  /** Additional sx for outer Snackbar */
  sx?: Record<string, unknown>;
}

const SnackbarAlert: React.FC<SnackbarAlertProps> = ({
  snackbar,
  onClose,
  autoHideDuration = 4000,
  anchorOrigin = { vertical: 'bottom', horizontal: 'center' },
  sx,
}) => (
  <Snackbar
    open={snackbar.open}
    autoHideDuration={autoHideDuration}
    onClose={onClose}
    anchorOrigin={anchorOrigin}
    sx={sx}
  >
    <Alert onClose={onClose} severity={snackbar.severity} variant="filled">
      {snackbar.message}
    </Alert>
  </Snackbar>
);

export default SnackbarAlert;
